import { Button, IconButton, Snackbar } from '@material-ui/core';
import { FormatColorFill } from '@material-ui/icons';
import { menuxSocketUrl } from 'POSClient';
import React, { useContext, useEffect, useRef, useState } from 'react';
import io from 'socket.io-client';
import CloseIcon from '@material-ui/icons/Close';
import { StandardDialog } from '@ifca-root/react-component/src/components/Dialog/StandardDialog';
import { SocketContext } from 'containers/Socket/SocketContext';
export const ADEWrapper = ({ children }) => {
	const [open, setOpen] = useState(false);
	const [message, setMessage] = useState('');
	const [notification, setNotification] = useState('');
	const [snckcolor, setcolor] = useState('');
	// const [socket, setSocket] = useState(null);
	const [color, setColor] = useState('');
	const [snackbarClosed, setsnackbarClosed] = useState(false);
	const [messages, setMessages] = useState('');
	const [ConfirmationDialog, setConfirmationDialog] = useState(false);
	const [messageColor, setMessageColor] = useState('black');

	const { socket }: any = useContext(SocketContext);
	const countdownRef = useRef<NodeJS.Timeout|null>(null);

	// useEffect(() => {
	// 	const newSocket = io(menuxSocketUrl);
	// 	setSocket(newSocket);

	// Cleanup function
	// 	return () => {
	// 		newSocket.disconnect();
	// 	};
	// }, []);

	//get notification
	useEffect(() => {
		if (socket) {
			socket.on('notification', notification => {
				// setNotification(() => notification.status);
				setNotification(notification.status);
				console.log(notification, 'notification');
			});

			return () => {
				if (socket) {
					socket.off('notification');
				}
			};
		}
	}, [socket]);

	useEffect(() => {
		
		try {
			if (notification === 'COMPLETED') {

				setConfirmationDialog(true);
				setMessages('Auto Day End is COMPLETED\n(Please make sure day end report data is all correct)');
				setMessageColor('#4cd038');
			
			
		} else if (notification === 'PENDING') {
			
				setConfirmationDialog(true);
				setMessages('Auto Day End is IN PROGRESS');
				setMessageColor('#FF0000');
		
			
		} else if (notification === 'START') {
				setOpen(true);
				
				if (countdownRef.current) {
					clearInterval(countdownRef.current);
				}
				let remainingTime = 30 * 60;
				// const countdownInterval 
				
				countdownRef.current= setInterval(() => {
					const minutes = Math.floor(remainingTime / 60);
					const seconds = remainingTime % 60;
					const formattedMinutes = String(minutes).padStart(2, '0');
					const formattedSeconds = String(seconds).padStart(2, '0');
					
					setMessage(
						`Auto Day End process will start in ${formattedMinutes} minutes time, please prepare for the closing now\n(not allow to download day end report while in progress)\n(night audit im progress)`,
					);
					remainingTime--;
					if (remainingTime < 0) {
						setMessage('Auto Day End process is starting...');
						// clearInterval(countdownInterval);
						clearInterval(countdownRef.current!);
						// setMessage('Auto Day End process is starting...');
						// Perform the actual process here
					}
					// console.log('countdownIterval123:',countdownInterval);
				}, 1000);
				
				// console.log('countdownIterval:',countdownInterval);
			}
		} catch (error) {
			console.error('Error handling disconnect:', error);
		}
		
	}, [notification]);

	const handleSnackbarClose = () => {
		setsnackbarClosed(true);
		setOpen(false);
	};
	// console.log(message, 'message nya');
	return (
		<>
			{children}
			{notification === 'START' ? (
				<Snackbar
					className=""
					style={{ top: '10px', right: '10px' }}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					open={open}
					autoHideDuration={3000}
					onClose={() => setOpen(true)}
					ContentProps={{
						'aria-describedby': 'message-id',
						style: { backgroundColor: 'white', color: 'red' },
					}}
					message={<span id="message-id"style={{whiteSpace:'pre-line'}}>{message}</span>}
					action={
						// Show IconButton with Close icon if notification is START
						<IconButton
							key="close"
							aria-label="close"
							color="inherit"
							onClick={handleSnackbarClose}
						>
							<CloseIcon />
						</IconButton>
					}
				/>
			) : (
				<StandardDialog
					fullWidth={true}
					open={ConfirmationDialog}
					onClose={() => {
						setConfirmationDialog(true);
					}}
					sections={{
						header: {
							title: 'Auto Day End',
						},
						body: () => (
							<div style={{ color: messageColor, fontWeight: 'bold', whiteSpace: 'pre-line' }}>
								{messages}
							</div>
						), // Add style here
						footer: {
							actions: [
								{
									displayText: 'OK',
									props: {
										onClick: () => {
											setConfirmationDialog(false);
										},
										variant: 'contained',
										color: 'primary',
										disabled: notification === 'PENDING',
									},
								},
							],
						},
					}}
				/>
			)}
		</>
	);
};
